import api from './api';

// Authentication service calls

export const authService = {
  /**
   * Login with username and password
   * @param {string} username
   * @param {string} password
   * @returns {Promise} { access_token, token_type, expires_in }
   */
  login: async (username, password) => {
    try {
      const response = await api.post('/auth/token', new URLSearchParams({
        username,
        password,
      }), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      
      // Store token in localStorage
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('token_type', response.data.token_type);
      localStorage.setItem('expires_in', response.data.expires_in);
      localStorage.setItem('login_time', Date.now());
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Get current user info
   * @returns {Promise} Current user data
   */
  getCurrentUser: async () => {
    try {
      const response = await api.get('/auth/me/permissions');
      const userInfo = response.data;
      localStorage.setItem('user_info', JSON.stringify(userInfo));
      return userInfo;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Logout (clear local storage)
   */
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('expires_in');
    localStorage.removeItem('user_info');
    localStorage.removeItem('login_time');
  },

  /**
   * Check if token is still valid
   * @returns {boolean}
   */
  isTokenValid: () => {
    const token = localStorage.getItem('access_token');
    const expiresIn = parseInt(localStorage.getItem('expires_in')) || 0;
    const loginTime = parseInt(localStorage.getItem('login_time')) || 0;
    const now = Date.now();

    if (!token) return false;
    
    // Check if token has expired (convert expiresIn from seconds to milliseconds)
    const expiryTime = loginTime + (expiresIn * 1000);
    return now < expiryTime;
  },

  /**
   * Get stored token
   * @returns {string|null}
   */
  getToken: () => localStorage.getItem('access_token'),

  /**
   * Get stored user info
   * @returns {object|null}
   */
  getUserInfo: () => {
    const userInfo = localStorage.getItem('user_info');
    return userInfo ? JSON.parse(userInfo) : null;
  },
};

export default authService;
